import { createSlice } from '@reduxjs/toolkit'
import { RootState } from './store'

interface ProfileState {
    status: number | null,
}

const previousUserStatus = localStorage.getItem('userStatus')
    ? localStorage.getItem('userStatus')
    : null

const initialState: ProfileState = {
    status: previousUserStatus ? Number.parseInt(previousUserStatus) : null,
}

const profileSlice = createSlice({
    name: 'profile',
    initialState: initialState,
    reducers: {
        setProfile: (state, action) => {
            state.status = action.payload?.status?.id;
            localStorage.setItem('userStatus', action.payload?.status?.id);
        },
    },
})

export const { setProfile } = profileSlice.actions

export default profileSlice.reducer

export const selectUserProfileStatus = (state: RootState): number | null => state.profile.status;
